import { render, staticRenderFns } from "./payModal.vue?vue&type=template&id=5b405dc0&scoped=true&"
import script from "./payModal.vue?vue&type=script&lang=js&"
export * from "./payModal.vue?vue&type=script&lang=js&"
import style0 from "./payModal.vue?vue&type=style&index=0&id=5b405dc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b405dc0",
  null
  
)

export default component.exports